import { di } from 'react-magnetic-di';

import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { useAIMateExperienceTracker } from '@atlassian/conversation-assistant-instrumentation/controllers/experience-tracker';
import { type ApiError } from '@atlassian/conversation-assistant-service-api/utils/api-error';
import { useQuery } from '@atlassian/conversation-assistant-service/common/utils/use-query';

import { getCloudUrlFromId } from '../../services/cloud-url/index.ts';

export const useTenantDataController = (siteId: string): {
    data: {
        cloudUrl: string;
        orgId: string;
    } | null | undefined;
    isFetching: boolean;
    error: ApiError | null;
} => {
	di(useQuery);

	const experience = useAIMateExperienceTracker();
	const { data, isFetching, error } = useQuery({
		queryKey: ['viewAgentTenantData', siteId],
		queryFn: async () => {
			experience.start({
				id: ExperienceName.FETCH_AGENT_TENANT_DATA,
				name: ExperienceName.FETCH_AGENT_TENANT_DATA,
			});
			const result = await getCloudUrlFromId(siteId);
			return result;
		},
		onSuccess: () => {
			experience.succeed({
				name: ExperienceName.FETCH_AGENT_TENANT_DATA,
			});
		},
		onError: (error: ApiError) => {
			experience.fail({
				name: ExperienceName.FETCH_AGENT_TENANT_DATA,
				error,
			});
		},
	});

	return { data, isFetching, error };
};
